import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import localforage from "localforage";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CustomTable from "../../../components/CustomTable";
import { filterList } from "../../../libs/utils";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import moment from "moment";
import { getRules, listRules } from "../../../services/Rules";
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";

function ListRules() {
  const [rows, setRows] = useState();
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [isDynamicTable, setIsDynamicTable] = useState(false);
  const [geTRules, setRules] = useState([]);
  const [opened, setOpen] = React.useState(false)

  const columns = [
    {
      id: "RuleName",
      label: "Rule Name",
      minWidth: 200,
      align: "left",
    },
    {
      id: "TxnDays",
      label: "Transaction Days",
      minWidth: 100,
      align: "center",
    },

    {
      id: "Active",
      label: "Active",
      minWidth: 100,
      align: "center",
    },
    {
      id: "MaxValue",
      label: "Max Value",
      minWidth: 100,
      align: "center",
    },
    {
      id: "Weight",
      label: "Weight",
      minWidth: 100,
      align: "left",
    },
    {
      id: "NormalizationFactor",
      label: "Normalization Factor",
      minWidth: 100,
      align: "left",
    },
    {
      id: "Action",
      label: "Action",
      minWidth: 100,
      align: "left",
    },
  ];

  const setDynamicTable = (parentWidth, tableWidth) => {
    setIsDynamicTable(true);
  };

  const searchData = (e) => {
    setSearchKey(e.target.value);
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dataGenerator = (data) => {
    
    return {
      RuleName: data.rule_name,
      TxnDays: data.txn_days,
      Active: String(data.active),
      MaxValue: data.max_value,
      Weight: data.weight,
      NormalizationFactor: data.normalization_factor,

      Action: (
        <Link to={`/app/rules/${data.id}`} style={{ textDecoration: "none" }}>
          <Button variant="contained" size="small" color="warning">
            Edit
          </Button>
        </Link>
      ),
    };
  };
  
  useEffect(() => {
    setLoading(true);
    localforage.getItem("@rules", (error, data) => {
      if (data) {
        if (data?.length > 0 && typeof data === "object") {
          setRows(data.map((data) => dataGenerator(data)));
        } else {
          setRows([]);
        }
      }
    });
    listRules()
      .then((response) => {
        setLoading(false);
        if (response?.length > 0 && typeof response === "object") {
          setRows(response.map((data) => dataGenerator(data)));
        } else {
          setRows([]);
        }
        localforage.setItem("@rules", response, (error, data) => {
          if (error) {
            throw error;
          }
        });
      })
      .catch((error) => {
        setLoading(false);
        throw error;
      });
  }, []);

  useEffect(() => {
    getRules()
      .then((response) => {
        setRules(response.eligible_csm_rules || []);
      })
      .catch(function (error) {
        throw error;
      });
  }, []);
  

const handleTooltipClose = ()=>{
  setOpen(false)
}

  return (
    <>
      <Box
        sx={{ px: 6 }}
        className={`main-box ${isDynamicTable ? "dynamicTableStyle" : ""}`}
      >
        <div
          className={`bankAddRuleHeader mb-3 ${
            isDynamicTable ? "listHeaderPaddingRight" : ""
          }`}
        >
          <div
            style={{
              display: "flex",
              padding: "1.5rem 0",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "#33343a" }} variant="h4" component="h4">
              Rules
            </Typography>
            {loading && (
              <div
                style={{
                  marginLeft: "12px",
                  color: "#a0a0a0",
                  fontSize: "24px",
                }}
              >
                <i
                  className={`fa fa-refresh ${
                    loading === true ? "fa-spin" : ""
                  }`}
                  aria-hidden="true"
                ></i>
              </div>
            )}
          </div>
          <div style={{ display: "flex", alignItems: "end" }}>
            <TextField
              id="standard-basic"
              label="Search"
              variant="standard"
              sx={{ mr: 1 }}
              onKeyUp={(e) => searchData(e)}
              InputProps={{
                endAdornment: <SearchIcon sx={{ color: "#8a8a8a" }} />,
              }}
            />
           
            <Tooltip title="Choose Option">
              <IconButton
                onClick={handleClick}
                size="small"
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
              >
                <MoreVertIcon sx={{ width: 32, height: 32 }} />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: "visible",
                  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                  mt: 1.5,
                  "& .MuiAvatar-root": {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  "&:before": {
                    content: '""',
                    display: "block",
                    position: "absolute",
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: "background.paper",
                    transform: "translateY(-50%) rotate(45deg)",
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem
                sx={{
                  "&:hover": {
                    background: "#f9da8792",
                    color: "#000",
                  },
                }}
              >
                {geTRules.length === 0 ? (
                  <div>
                      <Tooltip title="All the rules are already configured."
                onClose={handleTooltipClose}
                disableFocusListener
                open={opened}
                onOpen={()=>setOpen(true)}
                >
                   <Link to="/app/rules" style={{ color: "#040721" } }
                  onClick={(e)=>e.preventDefault()}>
                    Add New Rules
                  </Link>
                  </Tooltip>
                 
                  </div>
                 
                ) : (
                  <Link to="/app/rules/0" style={{ color: "#040721" }}>
                    Add New Rules
                  </Link>
                )}
                
            
              </MenuItem>
            
            </Menu>
          </div>
        </div>
      
        <CustomTable
          setDynamicTable={setDynamicTable}
          data={filterList(rows, searchKey) || []}
          columns={columns}
        />
      </Box>
    </>
  );
}

export default ListRules;
